/**
 * @generated SignedSource<<95cd8394637f5701eebd07db356f6617>>
 * @relayHash d3375e3232c100f609d67bddc827ea71
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9c320230d1c1a6923d7fc7376dff5ff7d3b6ff22af2b281ded725956f29917bc

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TownsquareUpdateStateFilter = "ACTIVE" | "AT_RISK" | "CANCELLED" | "DONE" | "NO_UPDATE" | "OFF_TRACK" | "ON_TRACK" | "PAUSED" | "PENDING" | "%future added value";
export type GoalUpdatesViewAggQuery$variables = {
  containerId: string;
  endDate: AGG$DateTime;
  followingGoalsSearchString: string;
  prevDate: AGG$DateTime;
  startDate: AGG$DateTime;
  stateFilter?: TownsquareUpdateStateFilter | null;
};
export type GoalUpdatesViewAggQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GoalUpdatesMainColumnAgg">;
};
export type GoalUpdatesViewAggQuery = {
  response: GoalUpdatesViewAggQuery$data;
  variables: GoalUpdatesViewAggQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "endDate"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "followingGoalsSearchString"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "prevDate"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "startDate"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stateFilter"
},
v6 = {
  "kind": "Variable",
  "name": "containerId",
  "variableName": "containerId"
},
v7 = {
  "kind": "Variable",
  "name": "endDate",
  "variableName": "endDate"
},
v8 = {
  "kind": "Variable",
  "name": "startDate",
  "variableName": "startDate"
},
v9 = {
  "kind": "Variable",
  "name": "stateFilter",
  "variableName": "stateFilter"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = {
  "kind": "Variable",
  "name": "createdAfter",
  "variableName": "startDate"
},
v12 = {
  "kind": "Variable",
  "name": "createdBefore",
  "variableName": "endDate"
},
v13 = [
  {
    "kind": "ScalarField",
    "name": "onTrack"
  },
  {
    "kind": "ScalarField",
    "name": "atRisk"
  },
  {
    "kind": "ScalarField",
    "name": "offTrack"
  },
  {
    "kind": "ScalarField",
    "name": "missed"
  },
  {
    "kind": "ScalarField",
    "name": "done"
  },
  {
    "kind": "ScalarField",
    "name": "cancelled"
  }
],
v14 = {
  "kind": "Literal",
  "name": "first",
  "value": 10
},
v15 = [
  (v6/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v14/*: any*/)
],
v16 = {
  "kind": "ScalarField",
  "name": "id"
},
v17 = {
  "kind": "ScalarField",
  "name": "missedUpdate"
},
v18 = {
  "kind": "ScalarField",
  "name": "updateType"
},
v19 = {
  "kind": "ScalarField",
  "name": "summary"
},
v20 = {
  "kind": "ScalarField",
  "name": "value"
},
v21 = {
  "kind": "ScalarField",
  "name": "score"
},
v22 = [
  (v20/*: any*/),
  (v21/*: any*/)
],
v23 = {
  "kind": "ScalarField",
  "name": "description"
},
v24 = {
  "kind": "ScalarField",
  "name": "archived"
},
v25 = {
  "concreteType": "TownsquareUpdateNoteConnection",
  "kind": "LinkedField",
  "name": "updateNotes",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareUpdateNoteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareUpdateNote",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v16/*: any*/),
            (v19/*: any*/),
            (v23/*: any*/),
            (v24/*: any*/)
          ]
        }
      ]
    }
  ]
},
v26 = {
  "kind": "TypeDiscriminator",
  "abstractKey": "__isTownsquareHighlight"
},
v27 = {
  "kind": "ScalarField",
  "name": "picture"
},
v28 = {
  "kind": "ScalarField",
  "name": "name"
},
v29 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v30 = [
  (v10/*: any*/),
  (v27/*: any*/),
  (v28/*: any*/),
  (v29/*: any*/),
  (v16/*: any*/)
],
v31 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v30/*: any*/)
},
v32 = {
  "kind": "LinkedField",
  "name": "lastEditedBy",
  "plural": false,
  "selections": (v30/*: any*/)
},
v33 = {
  "kind": "ScalarField",
  "name": "creationDate"
},
v34 = {
  "kind": "ScalarField",
  "name": "lastEditedDate"
},
v35 = {
  "kind": "ClientExtension",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__id"
    }
  ]
},
v36 = {
  "kind": "ScalarField",
  "name": "type"
},
v37 = {
  "kind": "ScalarField",
  "name": "subType"
},
v38 = {
  "kind": "ScalarField",
  "name": "source"
},
v39 = {
  "kind": "ScalarField",
  "name": "time"
},
v40 = {
  "concreteType": "TownsquareMetricValue",
  "kind": "LinkedField",
  "name": "latestValue",
  "plural": false,
  "selections": [
    (v39/*: any*/),
    (v16/*: any*/)
  ]
},
v41 = [
  (v20/*: any*/),
  (v39/*: any*/),
  (v16/*: any*/)
],
v42 = {
  "kind": "ScalarField",
  "name": "start"
},
v43 = {
  "kind": "ScalarField",
  "name": "scoringMode"
},
v44 = [
  (v20/*: any*/)
],
v45 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v46 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v44/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v45/*: any*/)
  ]
},
v47 = {
  "kind": "LinkedField",
  "name": "namePlural",
  "plural": false,
  "selections": [
    (v10/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v44/*: any*/),
      "type": "TownsquareGoalTypeCustomNamePlural"
    },
    (v45/*: any*/)
  ]
},
v48 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v49 = {
  "kind": "ScalarField",
  "name": "percentage"
},
v50 = {
  "concreteType": "TownsquareGoalProgress",
  "kind": "LinkedField",
  "name": "progress",
  "plural": false,
  "selections": [
    (v49/*: any*/),
    (v36/*: any*/)
  ]
},
v51 = {
  "concreteType": "TownsquareMetricTargetConnection",
  "kind": "LinkedField",
  "name": "metricTargets",
  "plural": false,
  "selections": [
    {
      "concreteType": "TownsquareMetricTargetEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "concreteType": "TownsquareMetricTarget",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v16/*: any*/),
            {
              "concreteType": "TownsquareMetric",
              "kind": "LinkedField",
              "name": "metric",
              "plural": false,
              "selections": [
                (v16/*: any*/),
                (v28/*: any*/),
                (v36/*: any*/),
                (v37/*: any*/),
                (v24/*: any*/),
                {
                  "kind": "ScalarField",
                  "name": "externalEntityId"
                },
                (v38/*: any*/),
                (v40/*: any*/)
              ]
            },
            {
              "concreteType": "TownsquareMetricValue",
              "kind": "LinkedField",
              "name": "snapshotValue",
              "plural": false,
              "selections": [
                (v20/*: any*/),
                (v16/*: any*/)
              ]
            },
            {
              "kind": "ScalarField",
              "name": "startValue"
            },
            {
              "kind": "ScalarField",
              "name": "targetValue"
            }
          ]
        }
      ]
    }
  ]
},
v52 = {
  "kind": "ScalarField",
  "name": "url"
},
v53 = {
  "concreteType": "TownsquareTargetDateRange",
  "kind": "LinkedField",
  "name": "dateRange",
  "plural": false,
  "selections": [
    (v42/*: any*/),
    {
      "kind": "ScalarField",
      "name": "end"
    }
  ]
},
v54 = {
  "concreteType": "TownsquareTargetDate",
  "kind": "LinkedField",
  "name": "targetDate",
  "plural": false,
  "selections": [
    (v53/*: any*/)
  ]
},
v55 = [
  (v10/*: any*/),
  (v29/*: any*/),
  (v28/*: any*/),
  (v27/*: any*/),
  (v16/*: any*/)
],
v56 = {
  "kind": "LinkedField",
  "name": "owner",
  "plural": false,
  "selections": (v55/*: any*/)
},
v57 = {
  "kind": "ScalarField",
  "name": "label"
},
v58 = {
  "kind": "LinkedField",
  "name": "creator",
  "plural": false,
  "selections": (v55/*: any*/)
},
v59 = [
  (v33/*: any*/),
  {
    "concreteType": "TownsquareGoalState",
    "kind": "LinkedField",
    "name": "newState",
    "plural": false,
    "selections": [
      (v20/*: any*/),
      (v21/*: any*/),
      (v57/*: any*/)
    ]
  },
  (v19/*: any*/),
  (v58/*: any*/),
  (v25/*: any*/),
  {
    "concreteType": "TownsquareHighlightConnection",
    "kind": "LinkedField",
    "name": "highlights",
    "plural": false,
    "selections": [
      {
        "concreteType": "TownsquareHighlightEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v10/*: any*/),
              (v16/*: any*/),
              (v19/*: any*/),
              (v23/*: any*/),
              (v26/*: any*/),
              (v31/*: any*/),
              (v32/*: any*/),
              (v33/*: any*/),
              (v34/*: any*/)
            ]
          }
        ]
      },
      (v35/*: any*/)
    ]
  },
  (v16/*: any*/)
],
v60 = {
  "concreteType": "TownsquareGoalUpdate",
  "kind": "LinkedField",
  "name": "latestUserUpdate",
  "plural": false,
  "selections": (v59/*: any*/)
},
v61 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v62 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v63 = {
  "kind": "ScalarField",
  "name": "key"
},
v64 = {
  "concreteType": "TownsquareGoalTypeIcon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v63/*: any*/)
  ]
},
v65 = {
  "concreteType": "TownsquareStatus",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v22/*: any*/)
},
v66 = [
  (v14/*: any*/)
],
v67 = {
  "kind": "ScalarField",
  "name": "editDate"
},
v68 = [
  {
    "concreteType": "TownsquareGoalUpdateEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "concreteType": "TownsquareGoalUpdate",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v67/*: any*/),
          (v33/*: any*/),
          (v16/*: any*/)
        ]
      }
    ]
  }
],
v69 = [
  (v16/*: any*/)
],
v70 = [
  (v57/*: any*/),
  (v53/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Fragment",
    "name": "GoalUpdatesViewAggQuery",
    "selections": [
      {
        "args": [
          (v6/*: any*/),
          (v7/*: any*/),
          {
            "kind": "Variable",
            "name": "followingGoalsSearchString",
            "variableName": "followingGoalsSearchString"
          },
          {
            "kind": "Variable",
            "name": "prevDate",
            "variableName": "prevDate"
          },
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "GoalUpdatesMainColumnAgg"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v5/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "GoalUpdatesViewAggQuery",
    "selections": [
      {
        "alias": "followingGoals",
        "args": [
          (v6/*: any*/),
          {
            "kind": "Literal",
            "name": "first",
            "value": 1
          },
          {
            "kind": "Variable",
            "name": "searchString",
            "variableName": "followingGoalsSearchString"
          }
        ],
        "concreteType": "TownsquareGoalConnection",
        "kind": "LinkedField",
        "name": "goals_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareGoalEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v10/*: any*/)
            ]
          }
        ]
      },
      {
        "alias": "allGoalUpdatesInPeriodCount",
        "args": [
          (v6/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v9/*: any*/)
        ],
        "kind": "ScalarField",
        "name": "goals_allWatchedGoalUpdatesCount"
      },
      {
        "alias": "currentSummary",
        "args": [
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/)
        ],
        "concreteType": "TownsquareStatusSummary",
        "kind": "LinkedField",
        "name": "goals_statusSummary",
        "plural": false,
        "selections": (v13/*: any*/)
      },
      {
        "alias": "previousSummary",
        "args": [
          (v6/*: any*/),
          {
            "kind": "Variable",
            "name": "endDate",
            "variableName": "startDate"
          },
          {
            "kind": "Variable",
            "name": "startDate",
            "variableName": "prevDate"
          }
        ],
        "concreteType": "TownsquareStatusSummary",
        "kind": "LinkedField",
        "name": "goals_statusSummary",
        "plural": false,
        "selections": (v13/*: any*/)
      },
      {
        "args": (v15/*: any*/),
        "concreteType": "TownsquareUpdateConnection",
        "kind": "LinkedField",
        "name": "goals_allWatchedGoalUpdates",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareUpdateEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v10/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v16/*: any*/),
                      (v17/*: any*/),
                      (v18/*: any*/),
                      (v19/*: any*/),
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "newState",
                        "plural": false,
                        "selections": (v22/*: any*/)
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDate"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "newTargetDateConfidence"
                      },
                      (v25/*: any*/),
                      {
                        "concreteType": "TownsquareHighlightConnection",
                        "kind": "LinkedField",
                        "name": "highlights",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareHighlightEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v19/*: any*/),
                                  (v23/*: any*/),
                                  (v10/*: any*/),
                                  (v16/*: any*/),
                                  (v26/*: any*/),
                                  (v31/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v34/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v35/*: any*/)
                        ]
                      },
                      (v33/*: any*/),
                      {
                        "concreteType": "TownsquareGoalMetricUpdateConnection",
                        "kind": "LinkedField",
                        "name": "metricUpdate",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalMetricUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalMetricUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetric",
                                    "kind": "LinkedField",
                                    "name": "metric",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v28/*: any*/),
                                      (v36/*: any*/),
                                      (v37/*: any*/),
                                      (v24/*: any*/),
                                      (v38/*: any*/),
                                      (v40/*: any*/),
                                      {
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                          },
                                          {
                                            "kind": "Literal",
                                            "name": "sort",
                                            "value": [
                                              "TIME_DESC"
                                            ]
                                          }
                                        ],
                                        "concreteType": "TownsquareMetricValueConnection",
                                        "kind": "LinkedField",
                                        "name": "values",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricValue",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": (v41/*: any*/)
                                              }
                                            ]
                                          }
                                        ],
                                        "storageKey": "values(first:100,sort:[\"TIME_DESC\"])"
                                      }
                                    ]
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "newValue",
                                    "plural": false,
                                    "selections": (v41/*: any*/)
                                  },
                                  {
                                    "concreteType": "TownsquareMetricValue",
                                    "kind": "LinkedField",
                                    "name": "oldValue",
                                    "plural": false,
                                    "selections": [
                                      (v39/*: any*/),
                                      (v16/*: any*/),
                                      (v20/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newStartValue"
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "newTargetValue"
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoal",
                        "kind": "LinkedField",
                        "name": "goal",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTargetConnection",
                            "kind": "LinkedField",
                            "name": "metricTargets",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricTargetEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareMetricTarget",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareMetric",
                                        "kind": "LinkedField",
                                        "name": "metric",
                                        "plural": false,
                                        "selections": [
                                          (v16/*: any*/),
                                          (v24/*: any*/)
                                        ]
                                      },
                                      {
                                        "concreteType": "TownsquareMetricTargetPeriodConnection",
                                        "kind": "LinkedField",
                                        "name": "metricTargetPeriods",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareMetricTargetPeriodEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareMetricTargetPeriod",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  {
                                                    "concreteType": "TownsquareTargetDate",
                                                    "kind": "LinkedField",
                                                    "name": "date",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "concreteType": "TownsquareTargetDateRange",
                                                        "kind": "LinkedField",
                                                        "name": "dateRange",
                                                        "plural": false,
                                                        "selections": [
                                                          (v42/*: any*/)
                                                        ]
                                                      }
                                                    ]
                                                  },
                                                  (v20/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      },
                                      (v16/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          (v16/*: any*/),
                          (v43/*: any*/),
                          (v24/*: any*/),
                          {
                            "concreteType": "TownsquareGoalType",
                            "kind": "LinkedField",
                            "name": "goalType",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  (v46/*: any*/),
                                  (v47/*: any*/),
                                  (v16/*: any*/)
                                ]
                              },
                              (v16/*: any*/)
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoalProgress",
                            "kind": "LinkedField",
                            "name": "progress",
                            "plural": false,
                            "selections": [
                              (v36/*: any*/)
                            ]
                          },
                          {
                            "args": (v48/*: any*/),
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "successMeasures",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v28/*: any*/),
                                      (v24/*: any*/),
                                      (v50/*: any*/),
                                      (v51/*: any*/),
                                      (v52/*: any*/),
                                      (v43/*: any*/),
                                      (v54/*: any*/),
                                      (v56/*: any*/),
                                      (v60/*: any*/),
                                      (v61/*: any*/),
                                      (v62/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          (v46/*: any*/),
                                          (v47/*: any*/),
                                          (v64/*: any*/),
                                          (v16/*: any*/)
                                        ]
                                      },
                                      (v65/*: any*/),
                                      {
                                        "args": (v66/*: any*/),
                                        "concreteType": "TownsquareGoalUpdateConnection",
                                        "kind": "LinkedField",
                                        "name": "updates",
                                        "plural": false,
                                        "selections": (v68/*: any*/),
                                        "storageKey": "updates(first:10)"
                                      }
                                    ]
                                  },
                                  (v10/*: any*/)
                                ]
                              }
                            ],
                            "storageKey": "successMeasures(first:50)"
                          },
                          {
                            "concreteType": "TownsquareGoalConnection",
                            "kind": "LinkedField",
                            "name": "subGoals",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoal",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v28/*: any*/),
                                      (v24/*: any*/),
                                      (v50/*: any*/),
                                      {
                                        "concreteType": "TownsquareGoalType",
                                        "kind": "LinkedField",
                                        "name": "goalType",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "ScalarField",
                                            "name": "kind"
                                          },
                                          (v16/*: any*/),
                                          (v64/*: any*/)
                                        ]
                                      },
                                      (v51/*: any*/),
                                      (v52/*: any*/),
                                      (v43/*: any*/),
                                      (v54/*: any*/),
                                      (v56/*: any*/),
                                      (v60/*: any*/),
                                      (v62/*: any*/),
                                      (v65/*: any*/),
                                      {
                                        "args": [
                                          {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 30
                                          }
                                        ],
                                        "concreteType": "TownsquareGoalUpdateConnection",
                                        "kind": "LinkedField",
                                        "name": "updates",
                                        "plural": false,
                                        "selections": (v68/*: any*/),
                                        "storageKey": "updates(first:30)"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "args": (v66/*: any*/),
                            "concreteType": "TownsquareGoalUpdateConnection",
                            "kind": "LinkedField",
                            "name": "updates",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalUpdateEdge",
                                "kind": "LinkedField",
                                "name": "edges",
                                "plural": true,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalUpdate",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      (v19/*: any*/),
                                      {
                                        "concreteType": "TownsquareUpdateNoteConnection",
                                        "kind": "LinkedField",
                                        "name": "updateNotes",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareUpdateNoteEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "concreteType": "TownsquareUpdateNote",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v19/*: any*/),
                                                  (v23/*: any*/),
                                                  (v16/*: any*/)
                                                ]
                                              }
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ],
                            "storageKey": "updates(first:10)"
                          },
                          {
                            "kind": "ScalarField",
                            "name": "isWatching"
                          },
                          (v61/*: any*/),
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canWatchGoal"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canCreateUpdates"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canEditUpdates"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "canDeleteUpdates"
                              }
                            ]
                          },
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "parentGoal",
                            "plural": false,
                            "selections": (v69/*: any*/)
                          },
                          (v63/*: any*/),
                          (v28/*: any*/),
                          {
                            "concreteType": "TownsquareGoalIcon",
                            "kind": "LinkedField",
                            "name": "icon",
                            "plural": false,
                            "selections": [
                              (v63/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "appearance"
                              }
                            ]
                          },
                          {
                            "kind": "ScalarField",
                            "name": "canPostUpdate"
                          },
                          (v62/*: any*/),
                          {
                            "kind": "ScalarField",
                            "name": "canEditUpdate"
                          },
                          {
                            "concreteType": "TownsquareGoalCapabilities",
                            "kind": "LinkedField",
                            "name": "capabilities",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "canCommentOnUpdates"
                              }
                            ]
                          }
                        ]
                      },
                      (v58/*: any*/),
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "newDueDate",
                        "plural": false,
                        "selections": (v70/*: any*/)
                      },
                      {
                        "args": (v48/*: any*/),
                        "concreteType": "TownsquareGoalBundledUpdateConnection",
                        "kind": "LinkedField",
                        "name": "bundledUpdates",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalBundledUpdateEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "successMeasure",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v49/*: any*/)
                                    ]
                                  },
                                  (v16/*: any*/)
                                ]
                              },
                              {
                                "concreteType": "TownsquareGoalUpdate",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": (v59/*: any*/)
                              },
                              {
                                "kind": "ScalarField",
                                "name": "nodeMissingReason"
                              },
                              {
                                "concreteType": "TownsquareGoal",
                                "kind": "LinkedField",
                                "name": "goal",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  (v28/*: any*/),
                                  {
                                    "concreteType": "TownsquareGoalProgress",
                                    "kind": "LinkedField",
                                    "name": "progress",
                                    "plural": false,
                                    "selections": [
                                      (v36/*: any*/),
                                      (v49/*: any*/)
                                    ]
                                  },
                                  (v51/*: any*/),
                                  (v52/*: any*/),
                                  (v43/*: any*/),
                                  (v54/*: any*/),
                                  (v56/*: any*/)
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "bundledUpdates(first:50)"
                      },
                      {
                        "kind": "LinkedField",
                        "name": "lastEditedBy",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v29/*: any*/),
                          (v28/*: any*/),
                          (v16/*: any*/)
                        ]
                      },
                      (v67/*: any*/),
                      (v52/*: any*/),
                      {
                        "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseConnection",
                        "kind": "LinkedField",
                        "name": "viewers",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "GraphStoreSimplifiedUserViewedGoalUpdateInverseEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v16/*: any*/),
                                      (v28/*: any*/),
                                      (v29/*: any*/),
                                      (v27/*: any*/)
                                    ],
                                    "type": "AtlassianAccountUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v69/*: any*/),
                                    "type": "AppUser"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v69/*: any*/),
                                    "type": "CustomerUser"
                                  }
                                ]
                              },
                              (v16/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "ari"
                      },
                      {
                        "concreteType": "TownsquareCommentConnection",
                        "kind": "LinkedField",
                        "name": "comments",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareCommentEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareComment",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v16/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "creator",
                                    "plural": false,
                                    "selections": [
                                      (v10/*: any*/),
                                      (v28/*: any*/),
                                      (v16/*: any*/),
                                      (v29/*: any*/),
                                      (v27/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "name": "commentText"
                                  },
                                  (v67/*: any*/),
                                  (v33/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v35/*: any*/)
                        ]
                      },
                      {
                        "concreteType": "TownsquareGoalState",
                        "kind": "LinkedField",
                        "name": "oldState",
                        "plural": false,
                        "selections": (v22/*: any*/)
                      },
                      {
                        "concreteType": "TownsquareTargetDate",
                        "kind": "LinkedField",
                        "name": "oldDueDate",
                        "plural": false,
                        "selections": (v70/*: any*/)
                      }
                    ],
                    "type": "TownsquareGoalUpdate"
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v69/*: any*/),
                    "type": "Node",
                    "abstractKey": "__isNode"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              }
            ]
          }
        ]
      },
      {
        "args": (v15/*: any*/),
        "filters": [
          "containerId",
          "createdBefore",
          "createdAfter",
          "stateFilter"
        ],
        "handle": "connection",
        "key": "GoalUpdatesList_goals_allWatchedGoalUpdates",
        "kind": "LinkedHandle",
        "name": "goals_allWatchedGoalUpdates"
      }
    ]
  },
  "params": {
    "id": "9c320230d1c1a6923d7fc7376dff5ff7d3b6ff22af2b281ded725956f29917bc",
    "metadata": {},
    "name": "GoalUpdatesViewAggQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "1777ec1c89d3b9ff381878c80e40ac4d";

export default node;
